import LoginCard from "./LoginCard";
import RegisterCard from "./RegisterCard";

const useLocalComponents = () => {
    return {
        LoginCard,
        RegisterCard
    };
}

export default useLocalComponents;